import { action } from 'easy-peasy';
import { IActionSetClientStandardAllocations } from '../types';

const setClientStandardAllocations: IActionSetClientStandardAllocations = action(
  (state, payload) => {
    const { items, pagination, filters } = payload;

    if (pagination) {
      state.standardPagination.pageNumber = pagination.pageNumber;
      state.standardPagination.pageSize = pagination.pageSize;
      state.standardPagination.total = pagination.total;
    }

    if (filters) {
      state.standardFilters = filters;
    }
    state.standardList = items;
  },
);

export default setClientStandardAllocations;
